var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-view"},[_c('panel-header',{attrs:{"is-offline":_vm.isOffline}}),(_vm.controlVoiceChecker)?_c('h2',[_vm._v(" "+_vm._s(_vm.$t('twitch.controlVoice'))+" ")]):_vm._e(),_c('router-view'),_c('panel-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }